import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ReplaceCardComponent } from '../../../../../shared/components/cards/replace-card/replace-card.component';
import { Card, CardType } from '../../../../../_interfaces/cards.interface';
import { ActivatedRoute } from '@angular/router';
import { CardsApiService } from '../../../../../_services/cards-service/cards-api/cards-api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-replace-subscription-card',
  imports: [ReplaceCardComponent],
  templateUrl: './replace-subscription-card.component.html',
})
export class ReplaceSubscriptionCardComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly cardsApiService = inject(CardsApiService);

  private readonly cardId: number;
  protected cardDetails?: Card;
  protected cardType: CardType = CardType.Subscription;
  readonly subscriptions = new Subscription();

  constructor() {
    const route = this.route;

    this.cardId = route.snapshot.params['id'];
  }

  ngOnInit() {
    this.cardsApiService.getSubscriptionCardById(this.cardId).subscribe((data) => (this.cardDetails = data));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
